<div
  mat-dialog-title
  class="d-flex justify-content-between align-items-center"
  [style.margin-bottom.px]="46"
>
  <h1 class="feedback-title h1 m-0">
    <span class="mr-2">{{ 'review_parcel' | translate }}</span>
    <strong>{{ number?.display || number?.trackingNumber }}</strong>
  </h1>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="closeModal()"
    mat-dialog-close="Close"
  >
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.29797 1.08288C1.96186 0.438518 3.03824 0.438518 3.70213 1.08288L11 8.16616L18.298 1.08288C18.9619 0.438518 20.0382 0.438518 20.7021 1.08288C21.366 1.72725 21.366 2.77197 20.7021 3.41634L13.4042 10.4996L20.7021 17.5829C21.366 18.2272 21.366 19.272 20.7021 19.9163C20.0382 20.5607 18.9619 20.5607 18.298 19.9163L11 12.8331L3.70213 19.9163C3.03824 20.5607 1.96186 20.5607 1.29797 19.9163C0.634076 19.272 0.634076 18.2272 1.29797 17.5829L8.59589 10.4996L1.29797 3.41634C0.634076 2.77197 0.634076 1.72725 1.29797 1.08288Z"
        fill="#324065"
      />
    </svg>
  </button>
</div>
<div
  mat-dialog-content
  [style.maxHeight]="'unset'"
  [style.overflow]="'visible'"
>
  <form [formGroup]="formGroup" #group="ngForm">
    <div class="review-row">
      <h3 class="feedback-text m-0">
        {{ 'carrier_review_title' | translate }}
      </h3>
      <div>
        <app-review-stars
          [disabled]="disabled"
          [value]="reviewState.carrierScore"
          (submitRating)="updateRating('carrierScore', $event)"
          [starSize]="{ width: 24.37, height: 23.27 }"
        ></app-review-stars>
        <div class="form-error-container">
          <p
            class="form-error"
            *ngIf="group?.submitted && !reviewState.carrierScore"
          >
            {{ 'review_required_message' | translate }}
          </p>
        </div>
      </div>
    </div>
    <div class="review-row">
      <h3 class="feedback-text m-0">
        {{ 'product_review_title' | translate }}
      </h3>
      <div>
        <app-review-stars
          [disabled]="disabled"
          [value]="reviewState.productScore"
          (submitRating)="updateRating('productScore', $event)"
          [starSize]="{ width: 24.37, height: 23.27 }"
        ></app-review-stars>
        <div class="form-error-container">
          <p
            class="form-error"
            *ngIf="group?.submitted && !reviewState.productScore"
          >
            {{ 'review_required_message' | translate }}
          </p>
        </div>
      </div>
    </div>
    <div class="review-row">
      <h3 class="feedback-text m-0">
        {{ 'package_review_title' | translate }}
      </h3>
      <div>
        <app-review-stars
          [disabled]="disabled"
          [value]="reviewState.packagingScore"
          (submitRating)="updateRating('packagingScore', $event)"
          [starSize]="{ width: 24.37, height: 23.27 }"
        ></app-review-stars>
        <div class="form-error-container">
          <p
            class="form-error"
            *ngIf="group?.submitted && !reviewState.packagingScore"
          >
            {{ 'review_required_message' | translate }}
          </p>
        </div>
      </div>
    </div>
    <div class="review-row">
      <div class="grow-1 w-100">
        <textarea
          [class.has-danger]="group?.submitted && comment.invalid"
          [formControl]="comment"
          class="feedback-textarea w-100"
          placeholder="{{ 'comments' | translate }}"
        ></textarea>
        <div class="form-error-container">
          <p
            class="form-error"
            *ngIf="group?.submitted && comment.hasError('required')"
          >
            {{ 'connents_required_message' | translate }}
          </p>
        </div>
      </div>
    </div>
    <div class="feedback-buttons">
      <div class="rating-block">
        <p class="feedback-text">{{ 'overall_rating' | translate }}:</p>
        <span class="ml-2 rating" [ngClass]="getClass()">
          {{ getCeilReview() }}
        </span>
      </div>
    </div>
    <div
      mat-dialog-actions
      *ngIf="
        !data ||
        !data.packagingScore ||
        !data.productScore ||
        !data.carrierScore ||
        !data.comment
      "
    >
      <button
        class="btn btn-default btn-submit-review"
        type="submit"
        (click)="submitReview()"
      >
        {{ 'submit_review' | translate | translate }}
      </button>
    </div>
  </form>
</div>
